import React from 'react';
import HighlightFeature, { BOTTOM } from '@/components/HighlightFeature';
import { userAction } from '@/util/helpers/ajax-helpers';

const STYLE = { minWidth: '290px', marginTop: '10px' };

export const InteractiveDemoSuggestion: React.FC = () => (
  <HighlightFeature
    position={BOTTOM}
    text={
      <span>
        Add&nbsp;
        <b>more steps</b> to build your query, or click&nbsp;
        <a
          style={{ color: '#fff', textDecoration: 'underline' }}
          href="https://trevor.io/#demo"
          target="_blank"
          onClick={() => userAction('open-interactive-demo')}
        >
          here
        </a>
        &nbsp;to try our interactive demo
      </span>
    }
    hideButton
    delay={0}
    style={STYLE}
  />
);
